
import React from 'react'
import leafRight from "../../assets/leaf-right.png"
import leafLeft from "../../assets/leaf-left.png"
import Slider from "react-slick";
import  styles from "../Common/Awards.module.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const Awards = () => {

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
          <div
            className={className}
            style={{ ...style, display: "block", background: "#E2E2E2" }}
            onClick={onClick}
          />
        );
      }
      
      function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
          <div
            className={className}
            style={{ ...style, display: "block", background: "#E2E2E2", }}
            onClick={onClick}
          />
        );
      }
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 640, // Adjust breakpoint according to your preference
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />
    // arrows: true,

  };
  
const CardDetails= [
  {
      id:1,
    date: '2023',
    title: 'Best Educational Platform Award',
    description: 'Recognized for outstanding learning tools and resources.'
  },
  // {
  //     id:2,
  //   date: '2022',  
  //   title: 'Innovative Teaching Methods Recognition',
  //   description: 'Honored for pioneering innovative online teaching methodologies.'
  // },
 
  {
      id:3,
    date: '2021',
    title: 'Excellence in User Experience',
    description: 'Awarded for providing a seamless and engaging user interface.'
  },
  {
      id:4,
    date: '2021',
    title: 'Top E-Learning Website 2024',
    description: 'Ranked as the leading e-learning website of the year.'
  },
  
  {
      id:5,
    date: '2021',
    title: 'Educational Impact Award',
    description: 'Celebrated for significant positive impact on student education.'
  },
  
 
 
];

  return (
     
      <div className='w-[80%] lg:w-[90%] mx-auto'>
         <Slider {...settings} className={styles.slider }>
    {CardDetails.map((CardDetail)=>(
      <div className={`${styles['Award-card']} mt-10 mb-6  hover:scale-105 transition-transform  `}>
      <div className={`${styles.leafleft}`}>
        <img src={leafLeft} alt="" width={50} height={112} />
      </div>
      <div className={`${styles.date}`}><span >
        <h2>{CardDetail.date}</h2>
      </span></div>
     <div className={`${styles.title}`}> <span >
        {CardDetail.title}
      </span></div>
      <div className={`${styles.description} `}><span >
        {CardDetail.description}
      </span></div>
      <div className={`${styles.leafRight}`}>
        <img src={leafRight} alt="" width={50} height={112}/>
      </div>
      </div>
    ))}
      </Slider>
      </div>
    
  )
}
export default Awards
